export default function(proArr) {
  return {
    type: "SET_PRO_ARRAY",
    proArr
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosMealArray/setProArr.js